export enum SystemNotificationSize {
  small = 'small',
  medium = 'medium',
  large = 'large'
}
